<template>
  <fts-design-modal
    class="fts-module-automation-panel-modal"
    ref="ftsDesignModal"
  >
    <template #title>
      <div class="design-modal-header-std__title">
        <font-awesome-icon :icon="['fas', 'play']" class="design-modal-header-icon" />
        <div class="design-modal-header-name">Automation and Notification Panel <fts-release-badge class="fts-align-top" /></div>
      </div>
    </template>

    <template #body>
      <fts-tabs>
        <fts-tab title="Automation">
          <template v-if="automationList.length">
            <fts-event-card
              v-for="event in automationList"
              :key="event.id"
              :event="event"
              @open="showAutomationDesignModal"
            />
          </template>
          <div class="panel-empty" v-else>Nothing here</div>
        </fts-tab>
        <fts-tab title="Notification">
          <template v-if="notificationList.length">
            <fts-event-card
              v-for="event in notificationList"
              :key="event.id"
              :event="event"
              @open="showAutomationDesignModal"
            />
          </template>
          <div class="panel-empty" v-else>Nothing here</div>
        </fts-tab>
        <!-- Studio schedules (docs/scheduling-routine-automation-proposal.md §2): shown when offered,
             or whenever the module has one (an administrator may have converted a timed automation) -->
        <fts-tab title="Scheduled" v-if="studioScheduleEnabled || scheduleList.length">
          <template v-if="scheduleList.length">
            <fts-event-card
              v-for="event in scheduleList"
              :key="event.id"
              :event="event"
              @open="showAutomationDesignModal"
            />
          </template>
          <div class="panel-empty" v-else>Nothing here. Add a Schedule from the module card.</div>
        </fts-tab>
        <fts-tab title="Script (Internal)" v-if="isInternal">
          <fts-script-search-list />
        </fts-tab>
        <fts-tab title="All">
          <template v-if="triggerList.length">
            <fts-event-card
              v-for="event in triggerList"
              :key="event.id"
              :event="event"
              @open="showAutomationDesignModal"
            />
          </template>
          <div class="panel-empty" v-else>Nothing here</div>
        </fts-tab>
      </fts-tabs>

      <fts-automation-design-modal ref="ftsAutomationDesignModal" />
    </template>
  </fts-design-modal>
</template>

<script>
import { store as canvasDesignStore } from '../store/canvasDesignStore';
import { authorizationStore } from '../store/authorizationStore';
import { isSchedule } from './schedule/scheduleLogic';

import FTSAutomationDesignModal from './FTSAutomationDesignModal';
import FTSDesignModal from './FTSDesignModal';
import FTSEventCard from './event/FTSEventCard';
import FTSReleaseBadge from '../elements/FTSReleaseBadge';
import FTSScriptSearchList from './script/FTSScriptSearchList';
import FTSTab from '../elements/tabs/FTSTab';
import FTSTabs from '../elements/tabs/FTSTabs';

export default {
  components: {
    'fts-automation-design-modal': FTSAutomationDesignModal,
    'fts-design-modal': FTSDesignModal,
    'fts-event-card': FTSEventCard,
    'fts-release-badge': FTSReleaseBadge,
    'fts-script-search-list': FTSScriptSearchList,
    'fts-tab': FTSTab,
    'fts-tabs': FTSTabs
  },
  methods: {
    show() {
      this.$refs.ftsDesignModal.show();
    },
    showAutomationDesignModal(item) {
      this.$refs.ftsAutomationDesignModal.show(item);
    }
  },
  computed: {
    isInternal() {
      return authorizationStore.getters.isInternal;
    },
    studioScheduleEnabled() {
      return authorizationStore.getters.appStudioSchedule;
    },
    automationList() {
      return canvasDesignStore.getters.vectorTriggers.filter((x) => x.actionType !== 'notification' && !isSchedule(x));
    },
    notificationList() {
      return canvasDesignStore.getters.vectorTriggers.filter((x) => x.actionType === 'notification' && !isSchedule(x));
    },
    scheduleList() {
      return canvasDesignStore.getters.vectorTriggers.filter(isSchedule);
    },
    triggerList() {
      return [...this.automationList, ...this.notificationList, ...this.scheduleList];
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-module-automation-panel-modal {
  .panel-empty {
    padding-top: 1.5rem;
    padding-bottom: 1rem;
    font-size: 0.875rem;
    line-height: 1rem;
    text-align: center;
    color: var(--fts-default);
  }
}
</style>